import OwnerPhoneNumber from './OwnerPhoneNumber';
export default OwnerPhoneNumber;